import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Placeholder.module.css';

// SEO-заглушки (заполнить при добавлении контента):
// title: «Информация о юр. лице — Терушкин ОС»
// description: «Юридические реквизиты организации клуба Терушкин ОС: ИНН, ОГРН, юридический адрес.»

const LegalInfo = () => {
  useEffect(() => {
    document.title = 'Информация о юр. лице — Терушкин ОС';
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <h1 className={styles.title}>Информация о юридическом лице</h1>
        <p className={styles.message}>
          Эта страница пока пустая. Здесь появятся юридические реквизиты организации:
          полное наименование, ИНН, ОГРН, юридический адрес.
        </p>
        {/* TODO: добавить реквизиты юридического лица */}
        <Link to="/" className={styles.back}>
          ← Вернуться на главную
        </Link>
      </div>
    </div>
  );
};

export default LegalInfo;
